<template>
    <div class="d-flex flex-column align-items-center px-5">
        <span class="font-xs text-secondary mb-2">You are about to pay</span>
        <span v-if="fontsize" class="merchat font-weight-bold  text-capitalize text-center">
            Lazada <br />
            (Reference No. {{ this.$root.$data.referenceNumber }})
            <br>
            &nbsp;
        </span>
        <span  v-else class="font-sm font-weight-bold text-gray-dk text-capitalize text-center">
            Lazada (Reference No. {{ this.$root.$data.referenceNumber }})
        </span>
    </div>
</template>

<script>
export default {
    props: {
        fontsize: Boolean,
        default: false
    },
}
</script>

<style scoped>
.merchat {
    font-size: 20px;
}
</style>